/**
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

import React from 'react';
import { LabeledCheckbox } from './CommonOverlayComponents';
import { Checkbox, Typography } from '@mui/material';
import { Hexagon } from '@mui/icons-material';
import styled from 'styled-components';

export const StyledHexagon = styled(Hexagon)`
  && {
    color: ${(props: { color: string }) => props.color};
    transform: rotate(90deg);
    margin-right: 4px;
    font-size: 20px;
  }
`;

interface GpsSaAccuracyCheckboxProps {
  opacity: number;
  checked: boolean;
  disabled: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  label: string;
  color: string;
}

const GpsSaAccuracyCheckbox = (props: GpsSaAccuracyCheckboxProps) => {
  const { opacity, checked, disabled, onChange, label, color } = props;

  return (
    <LabeledCheckbox
      classes={{ label: 'label' }}
      style={{
        opacity: opacity,
      }}
      control={
        <Checkbox
          checked={checked}
          disabled={disabled}
          style={{ color: 'white' }}
          disableRipple={true}
          value={label}
          onChange={onChange}
        />
      }
      label={
        <Typography
          component="span"
          className={'label'}
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <StyledHexagon color={color} />
          {label}
        </Typography>
      }
    />
  );
};

export default GpsSaAccuracyCheckbox;
